import {storeUserMetadata} from '../services/serviceDB';
import { useState } from 'react';
import * as PouchDB from 'pouchdb';
import PouchDBAuthentication from 'pouchdb-authentication';
PouchDB.default.plugin(PouchDBAuthentication)

var URL_DATABASE = process.env.REACT_APP_DB_URL
var db = new PouchDB.default(URL_DATABASE, {skip_setup: true});


export default function Login() {
  const [error, setError] = useState("")

  const signIn = async (event: any) => {
      event.preventDefault();
      let username = event.target.elements["username"].value
      let password = event.target.elements["password"].value

      db.logIn(username, password, async function (err, response) {
      if (err) {
        if (err.name === 'unauthorized' || err.name === 'forbidden') {
          setError((err.message) as any);
        } else {
          // cosmic rays, a meteor, etc.
        }
      } else {
        await storeUserMetadata(response).then(() => { window.location.reload(); });
      }
    })
    }

    return (
        <form className='login-box' onSubmit={signIn}>
          <h1> Se connecter </h1>
          <label htmlFor="username"><b>Nom d'utilisateur</b></label>
          <input type="text" placeholder="Nom d'utilisateur" name="username" required/>

          <label htmlFor="password"><b>Mot de passe</b></label>
          <input type="password" placeholder="Mot de passe" name="password" required/>

          <div className='error-message'>{error}</div>
          <input className="login-button" type="submit" value="Se connecter"/>
        </form>
    )
};
